<template>
    <AprProductsCarousel :blok="blok" :airport="airport" :products="products" :section-config="sectionConfig" />
</template>

<script lang="ts" setup>
import AprProductsCarousel from '~/components/sections/AprProductsCarousel.vue';
import type { IProductsSectionConfig } from '~/../types/ProductsCarousel';
defineProps<{
    blok: any;
    airport: any;
    products: any;
}>();

const sectionConfig: IProductsSectionConfig = {
    title: 'title',
    titleTag: 'h2',
    subtitle: {
        subtitleName: 'subtitle',
        subtitleType: 'text',
    },
    cardType: 'HotelOrParking',
};
</script>

<style scoped lang="postcss"></style>
